import { useState, useRef, useEffect } from 'react'
import { createModel } from 'hox'
import { getMobileCar, getVehicleOne, getOrderTeamList, virtualList } from '@/service/homeService'
import { message } from 'antd'
import close from '../../assets/images/close.png'
import { orderPispatchPlanOrderInfo } from '@/service/ordersService'
import { useHomePengddingOrderModel } from './homePengddingOrder'

const offline = `https://file-server.yunhaochefu.com/image/d6f8bd0a07561ecb483d6040a6214044`
const busy = `https://file-server.yunhaochefu.com/image/602c0eb2677f966f792847ebfce372d5`
const wait = `https://file-server.yunhaochefu.com/image/2937ccf8bbb24f5a971db39c61035668`

export const useHomeMapModel = createModel(function () {
    const { handleMapOrderIconClick, removeMarkerPengddingOrder, setRemoveMarkerPengddingOrder } = useHomePengddingOrderModel()

    const [showFull, setShowFull] = useState(false) //是否展示全屏

    // 地图相关的
    const mapRef = useRef({}) //地图容器
    const [mapInstance, setMapInstance] = useState(null)
    const autoRefreshRef = useRef(null)
    const markerTimerRef = useRef(null)
    const windowTimerRef = useRef(null)
    const markersRef = useRef(null) //地图车辆容器
    const vehicleWindowInfoRef = useRef(null) //地图车辆文字容器
    const [mapCenter, setMapCenter] = useState({ longitude: 116.397451, latitude: 39.909187 }) //地图中心点
    const [markers, setMarkers] = useState([])
    // 待派单订单Markers
    const [pengdingOrderMarkers, setPengdingOrderMarkers] = useState([])
    const pengdingOrderMarkersRef = useRef(null) //地图订单容器


    const [vehicleList, setVehicleList] = useState([]) //车辆列表

    useEffect(() => {
        if (removeMarkerPengddingOrder) {
            removePengdingOrderMarker(removeMarkerPengddingOrder)
        }
    }, [removeMarkerPengddingOrder])

    // 地图就绪后立即通知图层，避免依赖延时猜测初始化时机。
    const initMap = () => {
        if (mapRef.current.destroy) return
        const container = document.getElementById('map-box')
        if (!container || !window.TMap) return
        const map = new window.TMap.Map(container, {
            center: new window.TMap.LatLng(mapCenter.latitude, mapCenter.longitude),
            zoom: 11,
            noClear: false,
            showControl: false,
        })
        mapRef.current = map
        setMapInstance(map)
    }

    const destroyMap = () => {
        clearInterval(autoRefreshRef.current)
        clearTimeout(markerTimerRef.current)
        clearTimeout(windowTimerRef.current)
        ;[markersRef, pengdingOrderMarkersRef].forEach(ref => {
            if (ref.current) ref.current.forEach(marker => marker.destroy())
            ref.current = null
        })
        if (vehicleWindowInfoRef.current) vehicleWindowInfoRef.current.destroy()
        vehicleWindowInfoRef.current = null
        if (mapRef.current.destroy) mapRef.current.destroy()
        mapRef.current = {}
        setMapInstance(null)
    }

    const handleAutoRefresh = value => {
        clearInterval(autoRefreshRef.current)
        if (value) {
            getVehicles()
            autoRefreshRef.current = setInterval(getVehicles, 300000)
        }
    }

    const updateMakers = (makers) => {
        if (!mapRef.current.destroy) return
        clearTimeout(markerTimerRef.current)
        if (markersRef.current) {
            markersRef.current.forEach((maker) => {
                maker.destroy()
            })
            markersRef.current = null
        }

        markerTimerRef.current = setTimeout(() => {
            if (!mapRef.current.destroy) return
            markersRef.current = makers.map((item) => {
                let {
                    position: { latitude, longitude },
                    carStatus,
                    teamName,
                    course,
                } = item
                let url = null
                if (carStatus === 'offline') {
                    url = offline
                } else if (carStatus === 'busy') {
                    url = busy
                } else if (carStatus === 'wait') {
                    url = wait
                }
                course = item.course - 90
                return new window.TMap.InfoWindow({
                    map: mapRef.current,
                    position: new window.TMap.LatLng(latitude, longitude), //设置信息框位置
                    enableCustom: true,
                    content: `<div
                id="marker--${latitude}--${longitude}"
                style="width: 58px;
                    height: 26px;
                    color: #000;
                    textAlign: center;
                    position: relative;
                    cursor: pointer;"
                 >
                    <img
                        style="width: 58px;
                        height: 26px; 
                        transform: rotate(${course}deg);"
                        src="${url}" />
                    <div  
                        style="
                        width:58px;
                        height: 26px;
                        transform: rotate(${course}deg); position: absolute;
                        left: 0px;
                        top: 0;">
                    <span
                        style="
                            width:58px;
                            height: 26px;
                            font-size: 8px;
                            color: #fff;
                            line-height: 13px;
                            text-align: center;
                            transform: ${course > 90 || course < -90 ? 'rotate(180deg)' : 'rotate(0deg)'};
                            padding-${course > 90 || course < -90 ? 'left' : 'right'}: 20px;
                            display: block;
                            borderRadius: 10px;">  
                        ${teamName && teamName.substring(0, 8)}
                    </span>
                </div>
               
            </div>`, //设置信息框内容
                })
            })

            makersAddClick(makers)
        }, 500)
    }

    const makersAddClick = (makers) => {
        if (!mapRef.current.destroy || makers.length === 0) {
            return
        }
        let {
            position: { latitude, longitude },
        } = makers[0]
        if (document.getElementById(`marker--${latitude}--${longitude}`)) {
            makers.forEach((item) => {
                let {
                    position: { latitude, longitude },
                } = item
                const element = document.getElementById(`marker--${latitude}--${longitude}`)
                if (!element) return
                element.onclick = function () {
                    openVehicleWindowInfo(item)
                }
            })
        } else {
            clearTimeout(markerTimerRef.current)
            markerTimerRef.current = setTimeout(() => {
                makersAddClick(makers)
            }, 500)
        }
    }

    const openVehicleWindowInfo = async (item) => {
        const map = mapRef.current
        if (!map.destroy) return
        clearTimeout(windowTimerRef.current)
        if (vehicleWindowInfoRef.current && vehicleWindowInfoRef.current.destroy) {
            vehicleWindowInfoRef.current.destroy()
        }
        const { position } = item
        setMapCenter(position)
        if (item.vehicleId == null) {
            return
        }
        let vehicle = await getVehicleOne(item.vehicleId)
        let orderList = await getOrderTeamList({
            pageSize: 1,
            pageNum: 1,
            searchItem: {
                teamId: item.teamId,
                orderFlag: 0,
            },
        })
        if (mapRef.current !== map) return
        if (vehicle.retCode !== 200) {
            return message.error(vehicle.retMsg)
        }
        if (orderList.retCode !== 200) {
            return message.error(orderList.retMsg)
        }

        let geocoder = new window.TMap.service.Geocoder()
        // 地址逆解析
        geocoder
            .getAddress({ location: new window.TMap.LatLng(position.latitude, position.longitude) }) // 将给定的坐标位置转换为地址
            .then((res) => {
                if (mapRef.current !== map) return
                const checkedVehicle = {
                    ...vehicle.retData,
                    formattedAddress: res.result.address,
                    ...item,
                    orderList: orderList.retData.list,
                }
                vehicleWindowInfoRef.current = new window.TMap.InfoWindow({
                    map,
                    position: new window.TMap.LatLng(position.latitude, position.longitude), //设置信息框位置
                    enableCustom: true,
                    offset: { x: 0, y: -40 },
                    content: `<div><div class="window-info">
                    <img class="window-close" id="window-info-close" src=${close} />
                    <div class="window-info-title">
                        ${checkedVehicle.vehicleCode}
                        <span>${checkedVehicle.teamName}</span>
                    </div>
                    <div class="window-info-main">
                        <div class="window-info-tab-title">
                            <span id="window-info-tab-title-base" class="window-info-active">
                                基本信息
                            </span>
                            <span id="window-info-tab-title-vehicle">
                                车辆信息
                            </span>
                        </div>
                        <div class="window-info-content"  id="window-info-tab-title-base-box">
                            <div>
                                <span>车辆牌照：</span>
                                ${checkedVehicle?.vehicleCode || ''}
                            </div>
                            <div>
                                <span>当前位置：</span>
                                ${checkedVehicle?.formattedAddress || ''}
                            </div>
                            <div>
                                <span>速度：</span>
                                ${checkedVehicle?.speed || ''}
                            </div>
                            <div>
                                <span>报警：</span>
                                ${checkedVehicle?.alarm === 1 ? '是' : '否'}
                            </div>
                            <div>
                                <span>方向：</span>
                                ${checkedVehicle?.course || ''}
                            </div>
                            <div>
                                <span>状态：</span>
                                ${checkedVehicle?.status || ''}
                            </div>
                        </div>
                        <div class="window-info-content"  id="window-info-tab-title-vehicle-box">
                            <div>
                                <span>车辆牌照：</span>
                                ${checkedVehicle?.vehicleCode || ''}
                            </div>
                            <div>
                                <span>车辆品牌：</span>
                                ${checkedVehicle?.vehicleBrand || ''}
                            </div>
                            <div>
                                <span>车辆类型：</span>
                                ${checkedVehicle?.vehicleType || ''}
                            </div>
                            <div>
                                <span>联系电话：</span>
                                ${checkedVehicle?.userPhone || ''}
                            </div>
                            <div>
                                <span>设备号：</span>
                                ${checkedVehicle?.vehicleEquipmentCode || ''}
                            </div>
                            <div>
                                <span>VIN号：</span>
                                ${checkedVehicle?.vehicleVin || ''}
                            </div>
                        </div>
                    </div>
                </div></div>`, //设置信息框内容
                })
                setWindowInfoTabStyle()
            })
    }

    const setWindowInfoTabStyle = () => {
        if (!mapRef.current.destroy || !vehicleWindowInfoRef.current) return
        const base = window.document.getElementById(`window-info-tab-title-base`)
        const close = window.document.getElementById(`window-info-close`)
        const vehicle = window.document.getElementById(`window-info-tab-title-vehicle`)
        const baseBox = window.document.getElementById(`window-info-tab-title-base-box`)
        const vehicleBox = window.document.getElementById(`window-info-tab-title-vehicle-box`)
        if (base && vehicle && baseBox && vehicleBox) {
            base.onclick = function () {
                base.setAttribute('class', 'window-info-active')
                vehicle.setAttribute('class', '')
                baseBox.style.display = 'block'
                vehicleBox.style.display = 'none'
            }
            vehicle.onclick = function () {
                vehicle.setAttribute('class', 'window-info-active')
                base.setAttribute('class', '')
                vehicleBox.style.display = 'block'
                baseBox.style.display = 'none'
            }
            close.onclick = function () {
                vehicleWindowInfoRef.current.destroy()
                vehicleWindowInfoRef.current = null
            }
        } else {
            windowTimerRef.current = setTimeout(() => {
                setWindowInfoTabStyle()
            }, 1000)
        }
    }

    // 获取车辆
    const getVehicles = async (searchItem = {}) => {
        let markers = []

        await Promise.all([
            getMobileCar({
                pageSize: 10000,
                pageNum: 1,
                searchItem,
            }).then((res) => {
                res.retData.list.forEach((item) => {
                    if (item.lng && item.lat) {
                        markers.push({
                            position: {
                                longitude: item.lng,
                                latitude: item.lat,
                            },
                            ...item,
                        })
                    }
                })
                setVehicleList(res.retData.list)
            }),
            virtualList().then((res) => {
                res.retData.forEach((item) => {
                    if (item.lng && item.lat) {
                        let lng = parseFloat(item.lng) + parseFloat((Math.random() / 200).toFixed(6))
                        let lat = parseFloat(item.lat) + parseFloat((Math.random() / 200).toFixed(6))
                        markers.push({
                            ...item,
                            position: {
                                longitude: lng,
                                latitude: lat,
                            },
                        })
                    }
                })
            }),
        ])
            .then((result) => console.log('获取车辆完成'))
            .catch((e) => console.log('获取车辆错误' + e))
        setMarkers(markers)
    }

    const handleAddOrderMarker = (orderId) => {
        orderPispatchPlanOrderInfo(orderId).then((res) => {
            const { orderStatus } = res.retData
            //判断订单是待派单状态
            if (orderStatus === 'pending_order') {
                setPengdingOrderMarkers(current => [...current.filter(item => item.orderId !== orderId), res.retData])
            }
        })
    }

    //更新订单提示
    const updatePengdingOrderMarkers = (orders) => {
        if (!mapRef.current.destroy) return
        if (pengdingOrderMarkersRef.current) {
            pengdingOrderMarkersRef.current.forEach((maker) => {
                maker.destroy()
            })
        }
        pengdingOrderMarkersRef.current = orders.map((item, index) => {
            const { orderId, repairLat, repairLng } = item
            if (index === orders.length - 1) {
                //最后一个设置为地图中心点
                setMapCenter({ longitude: repairLng, latitude: repairLat })
            }
            return new window.TMap.InfoWindow({
                map: mapRef.current,
                position: new window.TMap.LatLng(repairLat, repairLng), //设置信息框位置
                enableCustom: true,
                offset: { x: 0, y: -40 },
                content: `<img class="window-order-icon" id="${orderId}"  src='https://file-server.yunhaochefu.com/image/46161acd73a2bdac1ca63bd24bcb2792' />`,
            })
        })

        orders.forEach((item) => {
            const { orderId, repairLat, repairLng } = item
            const element = window.document.getElementById(orderId)
            if (!element) return
            element.onclick = function () {
                setMapCenter({ longitude: repairLng, latitude: repairLat })
                handleMapOrderIconClick(orderId)
            }
        })
    }

    //移除订单提示
    const removePengdingOrderMarker = (orderId) => {
        setPengdingOrderMarkers(current => current.filter(item => item.orderId !== orderId))
        window.dispatchEvent(new Event('home-outdoor-repairs-changed'))
        setRemoveMarkerPengddingOrder('')
    }

    return {
        showFull,
        setShowFull,
        handleAutoRefresh,
        initMap,
        getVehicles,
        vehicleList,
        markers,
        updateMakers,
        mapCenter,
        mapRef,
        mapInstance,
        destroyMap,
        openVehicleWindowInfo,
        handleAddOrderMarker,
        pengdingOrderMarkers,
        updatePengdingOrderMarkers,
        setPengdingOrderMarkers,
        removePengdingOrderMarker,
    }
})
